<template>
  <div class="home-page login-content" style="padding-top: 0;">
		<div class="">
      <div class="login login-send">
        <div class="">
          <div class="home-prize">
            <div class="home1">
                <div class="pt20">
                  <a class="logo" style="text-align: left;margin: 0 20px -80px;position: relative;" href="/"><img src="static/images/logo.png" /></a>
                </div>
              <img width="100%" src="../../static/images/send.jpg" />
            </div>
          </div>
          <div class="input-div" style="margin-top: -2rem;position: relative;z-index: 10;">
            <div class="fs50 crfff mt30" style="width: 90%;margin:0 auto" v-html="$t('Login')"></div>
            <div class="span mt30 fs33 crfff fw7" style="font-weight: 400;margin-bottom: 15px;">{{$t('loginTips')}}</div>
            <div class="input-item mt50">
              <div class="input-item2 ">
                <span class="app-en" style="height: 0.8rem;
    border-radius: 1rem;
    line-height: 0.8rem;
    font-size: 0.3rem;
    font-weight: 700;">09</span>
                <input class="input" v-model="mobile" type="number" placeholder="">
              </div>
            </div>
          </div>
          <div class="ac mt50">
            <button class="button fw7" @click="goLogin">{{$t('Login')}}</button>
          </div>
          <div class="ac otp-b disflex mt100">
            <div style="color: white" class="icon icon2" @click="getType('termsAndCondition')">{{$t('TC')}} <span class="app-en">>></span></div>
            <div style="color: white" class="icon icon2" @click="getType('faq')">{{$t('FAQ')}} <span class="app-en">>></span></div>
          </div>
        </div>
      </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/HeaderTwo'
export default {
    components:{
		Header
    },
    data() {
      return {
        list:[],
        mobile:'',
        password:'',

      }
    },
	created(){
    if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
	},
    methods: {
      getType(type){
          this.$router.push({path:'/'+type,query:{type:type}});
      },
		back(){
			this.$router.go(-1);
		},

		goLogin(){
		  let that = this
		  if(that.mobile==''){
		  	that.$utils.alertText(that.$t('loginTips'),60)
		  	return;
		  }
      let mobile = '96'+this.mobile
      var code  = this.$route.query.code
      let data ={
        'mobile':mobile,
      }
      that.$parent.loadModal(true);
      //检测号码
      that.$api.post('/api/user/check_user',data,r =>{
        that.$parent.loadModal(false);
        if(r.code==1){
          localStorage.setItem('token',r.data.userinfo.token)
          localStorage.setItem('mobile',r.data.userinfo.mobile)
          that.isShowlogin = false
          that.mobile = ''
          this.$router.push({path:'/'})
        }else if(r.code==-1){
          this.go_sub()
          //this.$router.push({path:'/otp',query:{mobile:this.mobile,code:code}})
        } else{
          that.$utils.alertText(r.msg,100,3000);
        }
      })

		},
    go_sub(){
      let that = this
      let mobile = '96'+this.mobile
      var channelId  = this.$route.query.channelId
      var tracker  = this.$route.query.tracker
      var code  = this.$route.query.code
      var type  = this.$route.query.type
      that.$parent.loadModal(true);
      var data = {mobile: mobile, password: this.passwd,type:type,channelId:channelId,tracker:tracker,code:code}
      that.$api.post('/api/user/sub',data,r =>{
        that.$parent.loadModal(false);
        if (r.code == 1){
          that.$parent.returnCode(r,function(){
            localStorage.setItem('token',r.data.userinfo.token)
            localStorage.setItem('mobile',r.data.userinfo.mobile)
            that.$router.push('/');
          });
        }else{
          that.$utils.alertText(r.msg,100, 3000);
        }

      })
    }
	}
}
</script>
<style scoped>
  .drop-down-content{z-index:9;background:none;}
  .mt100{margin-top:100px;}
  .otp-b{justify-content: space-evenly;}
</style>



// WEBPACK FOOTER //
// src/page/LoginNew.vue